import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import DataObject from './index.js';
import schoolHelper from 'helpers/schoolHandling';
import { isUserTeacher, isUserAdministrator, isUserCourseAdministrator, isUserMentor, isUserStudent, isUserCurriculumAdmin, isUserAuthoritative, isUserPedagogue } from 'helpers/user';

var User = /*#__PURE__*/function (_DataObject) {
  _inherits(User, _DataObject);

  var _super = _createSuper(User);

  function User() {
    var _this;

    _classCallCheck(this, User);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getName", function () {
      if (_this.data != null) {
        return _this.data.firstName + ' ' + _this.data.lastName;
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "isTeacher", function () {
      return isUserTeacher(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isAdministrator", function () {
      return isUserAdministrator(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isCourseAdministrator", function () {
      return isUserCourseAdministrator(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isUserCurriculumAdmin", function () {
      return isUserCurriculumAdmin(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isMentor", function () {
      return isUserMentor(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isStudent", function () {
      return isUserStudent(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isAuthoritative", function () {
      return isUserAuthoritative(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isPedagogue", function () {
      return isUserPedagogue(_this.data);
    });

    _defineProperty(_assertThisInitialized(_this), "isSchoolLeader", function () {
      if (_this.data == null) {
        return false;
      }

      var school = schoolHelper.getSchoolForUser(_this.data);

      if (_this.data.roles != null && _this.data.roles.length > 0) {
        var role = _this.data.roles.find(function (role) {
          return role.roleId.toUpperCase() == 'SCHOOL_LEADER' && role.referenceType.toUpperCase() == 'SCHOOL' && role.referenceId == school;
        });

        if (role != null) {
          return true;
        }

        return false;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isOperationManager", function () {
      if (_this.data == null) {
        return false;
      }

      if (_this.data.userRoles != null && _this.data.userRoles.length > 0) {
        var role = _this.data.userRoles.find(function (role) {
          return role.toUpperCase() == 'OPERATION_MANAGER';
        });

        if (role != null) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isSMSAdmin", function () {
      if (_this.data == null) {
        return false;
      }

      var school = schoolHelper.getSchoolForUser(_this.data);

      if (_this.data.roles != null && _this.data.roles.length > 0) {
        var role = _this.data.roles.find(function (role) {
          return role.roleId.toUpperCase() == 'SMS_ADMIN' && role.referenceType.toUpperCase() == 'SCHOOL' && role.referenceId == school;
        });

        if (role != null) {
          return true;
        }

        return false;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "getActiveSchool", function () {
      if (_this.data == null) {
        return null;
      }

      var schoolId = schoolHelper.getSchoolForUser(_this.data);

      if (schoolId != null) {
        var school = _this.data.schools.find(function (school) {
          return school.id == schoolId;
        });

        if (school != null) {
          return school;
        }
      }

      return null;
    });

    return _this;
  }

  return _createClass(User);
}(DataObject);

export default User;